import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { DocumentModels } from '../models';
import { Observable, of } from 'rxjs';
import { FilterObjectBuilder, FilterOperator } from '../param-builders';
import { switchMap, map } from 'rxjs/operators';

@Injectable()
export class DocumentService extends CrudBaseService<DocumentModels.DocumentDetail> {

    constructor(httpClient: HttpClient) {
        super('/document', httpClient);
    }

    createDocumentThenUpload(body: DocumentModels.DocumentDetail, fileBinary: any): Observable<DocumentModels.AmazonS3DocumentBase> {
        return this.create(body)
            .pipe(
                map((res: any) => res.data),
                switchMap((result: DocumentModels.AmazonS3DocumentBase) => {
                    return this.httpClient.put(result.s3_object_id, fileBinary, {
                        headers: {
                            'is-external': 'true',
                            'Content-Type': 'application/octet-stream'
                        }
                    }).pipe(
                        switchMap(() => of(result))
                    );
                }));
    }

    getByContact(contactID: string): Observable<DocumentModels.DocumentDetail[]> {
        const filter = new FilterObjectBuilder();
        filter.by('contact_linked', FilterOperator.eq, contactID);
        return this.filter(filter.apiFilter());
    }
}
